export const officialHolidays = [
    { id: 'republicDay', name: 'Cumhuriyet Bayramı', date: '29 Ekim' },
    { id: 'newYearsDay', name: 'Yılbaşı', date: '1 Ocak' },
    { id: 'nationalSovereigntyAndChildrensDay', name: 'Ulusal Egemenlik ve Çocuk Bayramı', date: '23 Nisan' },
    { id: 'labourAndSolidarityDay', name: 'Emek ve Dayanışma Günü', date: '1 Mayıs' },
    { id: 'commemorationOfAtaturkYouthAndSportsDay', name: 'Atatürk\'ü Anma, Gençlik ve Spor Bayramı', date: '19 Mayıs' },
    { id: 'democracyAndNationalUnityDay', name: 'Demokrasi ve Millî Birlik Günü', date: '15 Temmuz' },
    { id: 'victoryDay', name: 'Zafer Bayramı', date: '30 Ağustos' },
];

export const holidayDates: { [year: string]: { [holidayId: string]: string } } = {
    '2025': {
        republicDay: '2025-10-29',
        newYearsDay: '2025-01-01',
        nationalSovereigntyAndChildrensDay: '2025-04-23',
        labourAndSolidarityDay: '2025-05-01',
        commemorationOfAtaturkYouthAndSportsDay: '2025-05-19',
        democracyAndNationalUnityDay: '2025-07-15',
        victoryDay: '2025-08-30',
    },
    '2026': {
        republicDay: '2026-10-29',
        newYearsDay: '2026-01-01',
        nationalSovereigntyAndChildrensDay: '2026-04-23',
        labourAndSolidarityDay: '2026-05-01',
        commemorationOfAtaturkYouthAndSportsDay: '2026-05-19',
        democracyAndNationalUnityDay: '2026-07-15',
        victoryDay: '2026-08-30',
    },
    '2027': {
        republicDay: '2027-10-29',
        newYearsDay: '2027-01-01',
        nationalSovereigntyAndChildrensDay: '2027-04-23',
        labourAndSolidarityDay: '2027-05-01',
        commemorationOfAtaturkYouthAndSportsDay: '2027-05-19',
        democracyAndNationalUnityDay: '2027-07-15',
        victoryDay: '2027-08-30',
    },
    '2028': {
        republicDay: '2028-10-29',
        newYearsDay: '2028-01-01',
        nationalSovereigntyAndChildrensDay: '2028-04-23',
        labourAndSolidarityDay: '2028-05-01',
        commemorationOfAtaturkYouthAndSportsDay: '2028-05-19',
        democracyAndNationalUnityDay: '2028-07-15',
        victoryDay: '2028-08-30',
    },
    '2029': {
        republicDay: '2029-10-29',
        newYearsDay: '2029-01-01',
        nationalSovereigntyAndChildrensDay: '2029-04-23',
        labourAndSolidarityDay: '2029-05-01',
        commemorationOfAtaturkYouthAndSportsDay: '2029-05-19',
        democracyAndNationalUnityDay: '2029-07-15',
        victoryDay: '2029-08-30',
    },
};
